// passing the path into variables

const banner1 = '/assets/pullmansur/Home/PullmandelSur-Website-Home-Slide-MainBanner-1.png';
const banner2 = '/assets/pullmansur/Home/PullmandelSur-Website-Home-Slide-MainBanner-2.png';
const banner3 = '/assets/pullmansur/Home/PullmandelSur-Website-Home-Slide-MainBanner-3.png';

const destination1 = '/assets/pullmansur/General/PullmandelSur-Website-Destinations-01.png';
const destination2 ='/assets/pullmansur/General/PullmandelSur-Website-Destinations-02.png';
const destination3 = '/assets/pullmansur/General/PullmandelSur-Website-Destinations-03.png';
const destination4 = '/assets/pullmansur/General/PullmandelSur-Website-Destinations-04.png';
const destination5 = '/assets/pullmansur/General/PullmandelSur-Website-Destinations-05.png';
const destination6 = '/assets/pullmansur/General/PullmandelSur-Website-Destinations-06.png';
const destination7 = '/assets/pullmansur/General/PullmandelSur-Website-Destinations-07.png';
const destination8 = '/assets/pullmansur/General/PullmandelSur-Website-Destinations-08.png';
const destination9 = '/assets/pullmansur/General/PullmandelSur-Website-Destinations-09.png';
const destination10 = '/assets/pullmansur/General/PullmandelSur-Website-Destinations-10.png';
const destination11 = '/assets/pullmansur/General/PullmandelSur-Website-Destinations-11.png';

const banner = [banner1, banner2, banner3];





const destination = [destination1, destination2, destination3, destination4,destination5,destination6,destination7,destination8,destination9,destination10,destination11];

const parcel1 = '/assets/pullmansur/parcel/PullmandelSur-Website-HomeV2-Bloque-28.png';
const parcel2 ='/assets/pullmansur/parcel/PullmandelSur-Website-HomeV2-Bloque-29.png';
const parcel3 = '/assets/pullmansur/parcel/PullmandelSur-Website-HomeV2-Bloque-30.png';
const parcel4 = '/assets/pullmansur/parcel/PullmandelSur-Website-HomeV2-Bloque-31.png';
const parcel5 = '/assets/pullmansur/parcel/PullmandelSur-Website-HomeV2-Bloque-32.png';
const parcel6 = '/assets/pullmansur/parcel/PullmandelSur-Website-HomeV2-Bloque-33.png';
const parcel7 = '/assets/pullmansur/parcel/PullmandelSur-Website-HomeV2-Bloque-34.png';
const parcel8 = '/assets/pullmansur/parcel/PullmandelSur-Website-HomeV2-Bloque-35.png';
const parcel9 = '/assets/pullmansur/parcel/PullmandelSur-Website-HomeV2-Bloque-36.png';
const parcel10 = '/assets/pullmansur/parcel/PullmandelSur-Website-HomeV2-Bloque-37.png';
const parcel11 = '/assets/pullmansur/parcel/PullmandelSur-Website-HomeV2-Bloque-38.png';
const parcel12 = '/assets/pullmansur/parcel/PullmandelSur-Website-HomeV2-Bloque-39.png';


const parcel = [parcel1, parcel2, parcel3, parcel4, parcel5, parcel6, parcel7, parcel8, parcel9, parcel10,parcel11, parcel12];
// const gallery = [gallery1, gallery2, gallery3, gallery4, gallery5, gallery6];

const pullmandelsurSlides = {
  banner,
  destination,
  parcel
};

export default pullmandelsurSlides;



// WEBPACK FOOTER //
// ./src/features/themes/functions/getSlides/pullmandelsurSlides.js